import React from 'react';
import '../css/herosection.css'; 

const HeroSection = () => (
  <div className="hero">
    <div className="hero-content container">
      <h1 className="hero-title">Pursync</h1>
      <h2 className="hero-subtitle">From Click to Care: Smarter Dermatology at Your Fingertips</h2>
      <p className="hero-description">
        Instant AI Skin Diagnosis, Backed by Experts.
      </p>
      <button className="btn-hero">Get Started</button>
    </div>
  </div>
);

export default HeroSection;
